export default __webpack_public_path__ + "static/media/therion.a8659774.jpg";